import { setLoadingUnique } from 'actions';
import * as mlApi from 'api/ml';
import { SET_AGENT_ASSIST_MACRO_RECOMMENDATION } from 'actions/types';

export const getAgentAssistMacro = (params) => async (dispatch) => {
  try {
    dispatch(setLoadingUnique(true, 'mlAssistPage'));
    const mlMacro = await mlApi.getAgentAssistResponse(params);
    dispatch(setAgentAssistMacroRecommendation(mlMacro.response));

    return mlMacro.response;
  } catch (error) {
    throw new Error('Something went wrong while grabbing the assisting macro.');
  } finally {
    dispatch(setLoadingUnique(false, 'mlAssistPage'));
  }
};

const setAgentAssistMacroRecommendation = (data) => ({
  type: SET_AGENT_ASSIST_MACRO_RECOMMENDATION,
  data,
});
